<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3 v-show="!registered">
          Sign Up For Free!
        </h3>
        <p v-show="!registered" class="subtitle" style="margin-bottom:8px">
          Get access to our daily email picks and more!
        </p>
        <div v-if="errors.any()" id="feedback">
          <p v-if="errors.has('fname')" class="error wrong_name error-box">
            Please enter a first name
          </p>
          <p v-if="errors.has('lname')" class="error wrong_email error-box">
            Please enter a last name
          </p>
          <p v-if="errors.has('email')" class="error wrong_message error-box">
            Please enter an email
          </p>
          <p
            v-if="errors.has('password')"
            class="error wrong_message error-box"
          >
            {{ errors.first("password") }}
          </p>
          <p
            v-if="errors.has('validateNumber')"
            class="error wrong_message error-box"
          >
            Please enter the spam protection number (5)
          </p>
        </div>
        <form v-show="!registered" name="formregister">
          <p>
            First Name:
            <input
              ref="fname"
              v-model="user.fname"
              v-validate="'required'"
              type="text"
              name="fname"
              maxlength="25"
              data-vv-delay="3000"
            />
          </p>
          <p>
            Last Name:
            <input
              v-model="user.lname"
              v-validate="'required'"
              type="text"
              name="lname"
              maxlength="25"
              data-vv-delay="2000"
            />
          </p>
          <p>
            Email: &nbsp; &nbsp; &nbsp; &nbsp;
            <input
              v-model="user.email"
              v-validate="'required|email'"
              type="text"
              name="email"
              maxlength="100"
              data-vv-delay="2000"
            />
          </p>
          <p>
            Password: &nbsp;
            <input
              v-model="user.password"
              v-validate="'required|confirmed:repeatpassword'"
              type="password"
              name="password"
              maxlength="30"
              data-vv-delay="2000"
            />
          </p>
          <p>
            Repeat PW
            <input
              id="label_name"
              v-model="user.confirmPassword"
              v-validate="'required'"
              type="password"
              name="repeatpassword"
              maxlength="30"
              data-vv-delay="2000"
            />
          </p>
          <p>
            2 + 3 = &nbsp; &nbsp; &nbsp;
            <input
              v-model="user.validateNumber"
              v-validate="{ required: true, regex: /^5$/ }"
              placeholder="5"
              type="number"
              name="validateNumber"
              maxlength="1"
              data-vv-delay="2000"
            />
          </p>
          <p>
            <input
              type="submit"
              value="Register"
              name="submitButton"
              class="big-btn grey"
              @click.prevent="signup"
            />
          </p>
          <br />
          <br />
        </form>
        <div v-show="registered">
          <div class="success-box">
            Thanks for signing up, you have been registered! Please
            <a id="success-login" href="#login-box">Log In.</a>
          </div>
          <div style="margin-top:24px">
            <h3>Purchase a Premium Membership</h3>
            <h5 v-for="p in ps" :key="p.id">
              {{ p.name }}
              <purchase-button :package="p"></purchase-button>
            </h5>
          </div>
        </div>
        <!-- main-colum END here -->
      </div>
      <!-- sidebar START here -->
      <div id="sidebar">
        <ul>
          <!-- widget START here -->
          <li class="widget">
            <div class="title">
              <h5>Membership Benefits</h5>
            </div>
            <div class="content">
              <ul>
                <li>Register for Free to Get Our Daily Email Pick</li>
                <li>Ability to View Free Picks</li>
                <li>Access to Powerful Handicapping Information</li>
                <li>Expert Analysis</li>
                <li>Quality Picks</li>
                <li>Excellent Customer Service</li>
                <li>Information is never disclosed or shared, ever!</li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <!-- container END here -->
    </div>
    <!-- content END here -->
  </div>
</template>

<script>
import PurchaseButton from "../components/purchaseButton.vue";
import AuthRepository from "../data/auth.repository";
import _ from "lodash";

export default {
  components: {
    purchaseButton: PurchaseButton,
  },
  data() {
    return {
      registered: false,
      user: {
        fname: "",
        lname: "",
        email: "",
        password: "",
        confirmPassword: "",
        validateNumber: ""
      }
    };
  },
  computed: {
    ps() {
      return this.$store.getters.packagesBySport(
        "2343a835-82ae-4b4b-bb50-689912b97571"
      ).filter(p => !p.special);
    },
  },
  mounted() {
    this.$refs.fname.focus();
    jQuery("#success-login")
      .first()
      .fancybox();
  },
  methods: {
    signup() {
      this.$validator.validateAll().then(() => {
        AuthRepository.register(this.user)
          .then(user => {
            this.registered = true;
          })
          .catch(e => {
            if (e.response.data) {
              console.log(e.response.data)
              let str = "";
              if (e.response.data.errors) {
                _.forOwn(e.response.data.errors, (value, key) => {
                  str += value.join(", ");
                });
              } else {
                str = e.response.data.message;
              }
              this.$root.$refs.toastr.e(str);
            } else this.$root.$refs.toastr.e(e);
          });
      });
    }
  },
  metaInfo: {
    title: "Register"
  }
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Register.vue?47fcf9f9